import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';

const ContattiPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Contatti' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Scrivici" title="Contatti" subtitle="Hai domande, proposte o vuoi metterti in contatto con noi? Siamo qui per te." />
      <section className="section"><div className="container"><div className="detail-layout">
        <div className="content-narrow">
          <div className="prose">
            <h2>Sede Nazionale</h2>
            <p>Via Sant'Andrea delle Fratte, 16<br />00187 Roma (RM)</p>
            <h2>Contatti diretti</h2>
            <p><strong>Email:</strong> <a href="mailto:info@giovanidemocratici.it" className="link">info@giovanidemocratici.it</a></p>
            <p><strong>PEC:</strong> <a href="mailto:gd@pec.giovanidemocratici.it" className="link">gd@pec.giovanidemocratici.it</a></p>
            <p><strong>Telefono:</strong> +39 06 6711 3200</p>
            <h2>Ufficio Stampa</h2>
            <p><strong>Email:</strong> <a href="mailto:stampa@giovanidemocratici.it" className="link">stampa@giovanidemocratici.it</a></p>
          </div>
          <h3 className="h4 mt-10 mb-4">Scrivici un messaggio</h3>
          <form style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
            <div className="grid grid-2" style={{ gap: 'var(--space-4)' }}>
              <input type="text" className="form-input" placeholder="Nome" />
              <input type="text" className="form-input" placeholder="Cognome" />
            </div>
            <input type="email" className="form-input" placeholder="Email" />
            <select className="form-input"><option>Seleziona argomento</option><option>Informazioni generali</option><option>Iscrizione</option><option>Stampa e media</option><option>Segnalazione</option><option>Altro</option></select>
            <textarea className="form-input" rows="5" placeholder="Il tuo messaggio..."></textarea>
            <button type="submit" className="btn btn--primary">Invia messaggio</button>
          </form>
        </div>
        <aside>
          <div className="org-block mb-6"><div className="org-block__title">Social</div>
            <div style={{ marginTop: 'var(--space-4)', display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
              {['Facebook', 'Instagram', 'Twitter/X', 'YouTube', 'TikTok'].map((s) => (
                <a href="#" className="link text-body-sm" key={s}>{s}</a>
              ))}
            </div>
          </div>
          <div className="org-block"><div className="org-block__title">Orari</div>
            <p className="text-body-sm text-secondary mt-4">Lun–Ven: 9:00–18:00<br />Sabato: su appuntamento<br />Domenica: chiuso</p>
          </div>
        </aside>
      </div></div></section>
    </Layout>
  );
};

export default ContattiPage;
